import React from "react";
import DynamicNavbar from "../components/DynamicNavbar";

const DynamicLayout = (props) => {
  return (
    <div className="min-h-screen">
      xwe(tuw)
      <DynamicNavbar />
      <div className="pt-10">{props.children}</div>
    </div>
  );
};

export default DynamicLayout;
